"use client";

import useBootstrapClient from "@/features/hooks/useBootstrapClient";
import { PageContainer } from "@/client/layout/PageContainer";
import { StoryboardProvider } from "../storyboard/context";
import StoryboardWorkspace from "../storyboard/components/StoryboardWorkspace";

interface StoryboardPageClientProps {
  locale: string;
}

const StoryboardPageClient: React.FC<StoryboardPageClientProps> = ({ locale }) => {
  void locale;
  useBootstrapClient();

  return (
    <StoryboardProvider>
      <PageContainer>
        <div className="flex flex-col gap-3 flex-1 min-h-0">
          <StoryboardWorkspace />
        </div>
      </PageContainer>
    </StoryboardProvider>
  );
};

export default StoryboardPageClient;
